import { useQuery } from "@apollo/client";
import { GET_NOTIFICATION_TEMPLATE_PROPERTIES_BY_CODE } from "../api/get-notification-template-properties-by-code";

export function useNotificationPropertiesByCode(code: string) {
  return useQuery(GET_NOTIFICATION_TEMPLATE_PROPERTIES_BY_CODE, {
    variables: { code },
  });
}
